import {z} from 'zod'

import {CreateOrUpdateBlockAppDownloadDocument} from '@sdox/api'

import {updateMetaSchema} from '../../utils/getUpdateMetaFromFieldValues'
import {createFormConfig} from '../../utils/createFormConfig'
import {i18nValidation} from '../../../../../i18n'

import type {BlockAppDownloadInput, CreateOrUpdateBlockAppDownloadMutation} from '@sdox/api'

export type UpdateAppDownloadValidatorSchema = z.infer<typeof updateAppDownloadValidatorSchema>

export const updateAppDownloadValidatorSchema = z.object({
  data: z.object({
    androidHref: z.string().url({message: i18nValidation.invalidUrl}),
    androidLabel: z.string().min(1, {message: i18nValidation.invalidAppName}),
    iosHref: z.string().url({message: i18nValidation.invalidUrl}),
    iosLabel: z.string().min(1, {message: i18nValidation.invalidAppName}),
  }),
  meta: updateMetaSchema,
})

export const appDownloadConfig = createFormConfig<
  UpdateAppDownloadValidatorSchema,
  CreateOrUpdateBlockAppDownloadMutation,
  BlockAppDownloadInput
>({
  mutationOptions: {
    mutation: CreateOrUpdateBlockAppDownloadDocument,
  },
  fieldMapper: ({data}) => ({
    androidHref: data.androidHref,
    androidLabel: data.androidLabel,
    iosHref: data.iosHref,
    iosLabel: data.iosLabel,
  }),
  validatorSchema: updateAppDownloadValidatorSchema,
  inputFields: [
    {
      label: 'Link to Google Play Store',
      fieldName: 'data.androidHref',
      inputType: 'link',
      defaultValue: '',
      required: true,
    },
    {
      label: 'App Name (Play Store)',
      fieldName: 'data.androidLabel',
      inputType: 'text',
      defaultValue: '',
      required: true,
    },
    {
      label: 'Link to Apple App Store',
      fieldName: 'data.iosHref',
      inputType: 'link',
      defaultValue: '',
      required: true,
    },
    {
      label: 'App Name (App Store)',
      fieldName: 'data.iosLabel',
      inputType: 'text',
      defaultValue: '',
      required: true,
    },
  ],
})
